import { FlagsService } from './model/squareup/feature/relay/flags/service';
import rpc from './rpc';

const flagsClient = FlagsService.create(rpc(() => '/1.0/features/get-flags'));

export const getFlags = flagsClient.getFlags;

export default flagsClient;
